import { ActionIconProps, ActionIcon } from "@mantine/core"
import {
  IconTrash,
  IconArrowBackUp,
  IconPencil,
  IconPlus,
  IconArrowUp,
  IconArrowDown,
  IconNote,
  IconList,
  IconArrowMergeLeft,
  IconArrowRampLeft2,
} from "@tabler/icons-react"

interface Props extends ActionIconProps {
  onClick?: React.MouseEventHandler<HTMLButtonElement>
}

export function DefaultActionIcon(props: Props) {
  return <ActionIcon variant={"subtle"} {...props} />
}

export function ActionIconTrash(props: Props) {
  return (
    <DefaultActionIcon c={"red"} {...props}>
      <IconTrash />
    </DefaultActionIcon>
  )
}

export function ActionIconArrowBackUp(props: Props) {
  return (
    <DefaultActionIcon {...props}>
      <IconArrowBackUp />
    </DefaultActionIcon>
  )
}

export function ActionIconPencil(props: Props) {
  return (
    <DefaultActionIcon {...props}>
      <IconPencil />
    </DefaultActionIcon>
  )
}

export function ActionIconPlus(props: Props) {
  return (
    <DefaultActionIcon {...props}>
      <IconPlus />
    </DefaultActionIcon>
  )
}

export function ActionIconArrowUp(props: Props) {
  return (
    <DefaultActionIcon {...props}>
      <IconArrowUp />
    </DefaultActionIcon>
  )
}

export function ActionIconArrowDown(props: Props) {
  return (
    <DefaultActionIcon {...props}>
      <IconArrowDown />
    </DefaultActionIcon>
  )
}

export function ActionIconNote(props: Props) {
  return (
    <DefaultActionIcon {...props}>
      <IconNote />
    </DefaultActionIcon>
  )
}

export function ActionIconList(props: Props) {
  return (
    <DefaultActionIcon {...props}>
      <IconList />
    </DefaultActionIcon>
  )
}

export function ActionIconArrowMergeLeft(props: Props) {
  return (
    <DefaultActionIcon {...props}>
      <IconArrowMergeLeft />
    </DefaultActionIcon>
  )
}

export function ActionIconArrowRampLeft2(props: Props) {
  return (
    <DefaultActionIcon {...props}>
      <IconArrowRampLeft2 />
    </DefaultActionIcon>
  )
}
